// extracted by mini-css-extract-plugin
export default {"root":"NavigationPath-modules__root__fEJtj","item":"NavigationPath-modules__item__t8d36","show-keyframe":"NavigationPath-modules__show-keyframe__HdIGy"};